import React from "react";
import { Box } from "@mui/material";
import LogoutIcon from "@icons/myicons/sidebar/logout.svg?react";
import RevertIcon from "@icons/myicons/sidebar/revert.svg?react";
import { useMandatorContext } from "@rentablo/theming";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { MenuGroup } from "@components/common/layouts/AppSidebar/SidebarMenu/MenuGroup.tsx";
import { getV1Url, MandatorConditional } from "@helpers";
import { MenuItem } from "@components";
import { useAppLayout } from "@providers/AppLayoutProvider";
import { HelpdeskMenuItem } from "./HelpdeskMenuItem";
import { UserIdField } from "./UserIdField";

export const UserMenu = () => {
  const { isRentablo } = useMandatorContext();
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const { sidebarCollapsed } = useAppLayout();

  return (
    <Box>
      {!sidebarCollapsed && (
        <MandatorConditional showFor={["kpmg-germany"]}>
          <UserIdField marginBottom={5} />
        </MandatorConditional>
      )}
      <MenuGroup>
        {isRentablo && (
          <MenuItem
            to={getV1Url()}
            name={t("appSidebar.menu.backToLegacy")}
            before={<RevertIcon />}
          />
        )}
        <HelpdeskMenuItem />
        <MenuItem
          to="/logout"
          name={t("appSidebar.menu.logout")}
          before={<LogoutIcon />}
          selected={pathname === "/logout"}
        />
      </MenuGroup>
    </Box>
  );
};
